"use client";

import { c as _c } from "react/compiler-runtime";
import { buttonVariants } from "@/components/ui/Button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import * as React from "react";
import { DayPicker } from "react-day-picker";
import cn from "twsx";
export type CalendarProps = React.ComponentProps<typeof DayPicker>;
export function Calendar(t0) {
  const $ = _c(17);
  let className;
  let classNames;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      showOutsideDays: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = classNames;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    classNames = $[2];
    props = $[3];
    t1 = $[4];
  }
  const showOutsideDays = t1 === undefined ? true : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("p-0 !m-0", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn(buttonVariants({
      variant: "secondary"
    }), "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100");
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn(buttonVariants({
      variant: "ghost"
    }), "h-8 w-8 p-0 font-normal aria-selected:opacity-100");
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== classNames) {
    t5 = {
      months: "flex flex-col sm:flex-row pb-2 sm:space-x-4 sm:space-y-0",
      month: "space-y-0",
      caption: "flex justify-center pl-2 py-2 justify-between relative  items-center",
      caption_label: "text-sm font-medium",
      nav: "flex items-start gap-2",
      nav_button: t3,
      nav_button_previous: "absolute left-1",
      nav_button_next: "absolute right-1",
      table: "w-full border-collapse space-y-1",
      head_row: "flex",
      head_cell: "text-text-tertiary rounded-md w-8 font-normal text-sm",
      row: "flex w-full my-0.5",
      cell: "h-8 w-8 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent-tint [&:has([aria-selected])]:bg-accent-tint first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
      day: t4,
      day_range_end: "day-range-end",
      day_selected: "bg-accent text-text-on-accent hover:bg-accent-hover hover:text-text-on-accent focus:bg-accent focus:text-text-on-accent",
      day_today: "bg-accent-tint text-accent",
      day_outside: "day-outside text-text-tertiary opacity-50 aria-selected:bg-accent-tint aria-selected:text-text-tertiary aria-selected:opacity-30",
      day_disabled: "text-text-tertiary opacity-50",
      day_range_middle: "aria-selected:bg-accent-tint aria-selected:text-accent",
      day_hidden: "invisible",
      ...classNames
    };
    $[9] = classNames;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      IconLeft: _temp,
      IconRight: _temp2
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props || $[13] !== showOutsideDays || $[14] !== t2 || $[15] !== t5) {
    t7 = <DayPicker showOutsideDays={showOutsideDays} className={t2} classNames={t5} components={t6} {...props} />;
    $[12] = props;
    $[13] = showOutsideDays;
    $[14] = t2;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp2() {
  return <ChevronRight className="h-4 w-4" />;
}
function _temp() {
  return <ChevronLeft className="h-4 w-4" />;
}